import { Navigate } from 'react-router-dom';

function HomePage() {
  return <Navigate to="/admin" replace />;
}

export default HomePage;
